/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerGuaranteeDto } from './BorrowerGuaranteeDto';
import {
    BorrowerGuaranteeDtoFromJSON,
    BorrowerGuaranteeDtoFromJSONTyped,
    BorrowerGuaranteeDtoToJSON,
    BorrowerGuaranteeDtoToJSONTyped,
} from './BorrowerGuaranteeDto';
import type { BorrowerContractualizationPricingDto } from './BorrowerContractualizationPricingDto';
import {
    BorrowerContractualizationPricingDtoFromJSON,
    BorrowerContractualizationPricingDtoFromJSONTyped,
    BorrowerContractualizationPricingDtoToJSON,
    BorrowerContractualizationPricingDtoToJSONTyped,
} from './BorrowerContractualizationPricingDto';

/**
 * Loan detail for a borrower with insurance configuration
 * @export
 * @interface BorrowerLoanDetailDto
 */
export interface BorrowerLoanDetailDto {
    /**
     * Unique loan identifier
     * @type {string}
     * @memberof BorrowerLoanDetailDto
     */
    id: string;
    /**
     * Loan amount in currency
     * @type {number}
     * @memberof BorrowerLoanDetailDto
     */
    loanAmount: number;
    /**
     * Total loan duration in months
     * @type {number}
     * @memberof BorrowerLoanDetailDto
     */
    totalDuration: number;
    /**
     * Interest rate type identifier
     * @type {string}
     * @memberof BorrowerLoanDetailDto
     */
    interestRateTypeId: string;
    /**
     * Interest rate percentage
     * @type {number}
     * @memberof BorrowerLoanDetailDto
     */
    interestRatePercentage: number;
    /**
     * Deferment type identifier
     * @type {string}
     * @memberof BorrowerLoanDetailDto
     */
    defermentTypeId: string;
    /**
     * Deferred period in months
     * @type {number}
     * @memberof BorrowerLoanDetailDto
     */
    defermentPeriod: number;
    /**
     * Loan type identifier
     * @type {string}
     * @memberof BorrowerLoanDetailDto
     */
    loanTypeId: string;
    /**
     * Insurance amount (optional)
     * @type {number}
     * @memberof BorrowerLoanDetailDto
     */
    insuranceAmount?: number | null;
    /**
     * 
     * @type {Array<BorrowerGuaranteeDto>}
     * @memberof BorrowerLoanDetailDto
     */
    guarantees?: Array<BorrowerGuaranteeDto>;
    /**
     * 
     * @type {BorrowerContractualizationPricingDto}
     * @memberof BorrowerLoanDetailDto
     */
    pricing?: BorrowerContractualizationPricingDto;
}

/**
 * Check if a given object implements the BorrowerLoanDetailDto interface.
 */
export function instanceOfBorrowerLoanDetailDto(value: object): value is BorrowerLoanDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('loanAmount' in value) || value['loanAmount'] === undefined) return false;
    if (!('totalDuration' in value) || value['totalDuration'] === undefined) return false;
    if (!('interestRateTypeId' in value) || value['interestRateTypeId'] === undefined) return false;
    if (!('interestRatePercentage' in value) || value['interestRatePercentage'] === undefined) return false;
    if (!('defermentTypeId' in value) || value['defermentTypeId'] === undefined) return false;
    if (!('defermentPeriod' in value) || value['defermentPeriod'] === undefined) return false;
    if (!('loanTypeId' in value) || value['loanTypeId'] === undefined) return false;
    return true;
}

export function BorrowerLoanDetailDtoFromJSON(json: any): BorrowerLoanDetailDto {
    return BorrowerLoanDetailDtoFromJSONTyped(json, false);
}

export function BorrowerLoanDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerLoanDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'loanAmount': json['loanAmount'],
        'totalDuration': json['totalDuration'],
        'interestRateTypeId': json['interestRateTypeId'],
        'interestRatePercentage': json['interestRatePercentage'],
        'defermentTypeId': json['defermentTypeId'],
        'defermentPeriod': json['defermentPeriod'],
        'loanTypeId': json['loanTypeId'],
        'insuranceAmount': json['insuranceAmount'] == null ? undefined : json['insuranceAmount'],
        'guarantees': json['guarantees'] == null ? undefined : ((json['guarantees'] as Array<any>).map(BorrowerGuaranteeDtoFromJSON)),
        'pricing': json['pricing'] == null ? undefined : BorrowerContractualizationPricingDtoFromJSON(json['pricing']),
    };
}

export function BorrowerLoanDetailDtoToJSON(json: any): BorrowerLoanDetailDto {
    return BorrowerLoanDetailDtoToJSONTyped(json, false);
}

export function BorrowerLoanDetailDtoToJSONTyped(value?: BorrowerLoanDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'loanAmount': value['loanAmount'],
        'totalDuration': value['totalDuration'],
        'interestRateTypeId': value['interestRateTypeId'],
        'interestRatePercentage': value['interestRatePercentage'],
        'defermentTypeId': value['defermentTypeId'],
        'defermentPeriod': value['defermentPeriod'],
        'loanTypeId': value['loanTypeId'],
        'insuranceAmount': value['insuranceAmount'],
        'guarantees': value['guarantees'] == null ? undefined : ((value['guarantees'] as Array<any>).map(BorrowerGuaranteeDtoToJSON)),
        'pricing': BorrowerContractualizationPricingDtoToJSON(value['pricing']),
    };
}

